import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FraudReviewStatus } from '../../../../fraud-dashboard.models';

@Component({
  selector: 'app-fraud-case-review',
  templateUrl: './fraud-case-review.component.html',
  styleUrls: ['../fraud-case-card.css', './fraud-case-review.component.css']
})
export class FraudCaseReviewComponent {
  @Input() status: FraudReviewStatus = 0;
  @Input() comment = '';
  @Input() saving = false;
  @Input() error = '';
  @Input() success = '';
  @Output() statusChange = new EventEmitter<FraudReviewStatus>();
  @Output() commentChange = new EventEmitter<string>();
  @Output() saveRequested = new EventEmitter<void>();
}
